// Legacy route — preserved for backward compatibility with bookmarked URLs.
// The new Google OAuth flow redirects directly from backend to "/" with query
// params — this page is no longer in the active flow. If someone lands here
// (e.g., from an old email link or a stale bookmark), bounce to the lobby.
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const nav = useNavigate();
  useEffect(() => {
    // Preserve any query params (e.g., ?signed_in=1&bonus=250) in case the
    // backend ever redirects here by mistake during rollout.
    const qs = window.location.search || "";
    nav("/" + qs, { replace: true });
  }, [nav]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center" data-testid="auth-callback-legacy">
      <div className="font-display font-bold text-white/65">Redirecting…</div>
    </div>
  );
}
